module.exports = __webpack_public_path__ + "img/104006.8db08a25.png";